import React from 'react';
import { useParams } from 'react-router-dom';
import ShopDetails from '../ShopDetails/ShopDetails';

const BusinessProfile = () => {
  const { businessName } = useParams();
  return <ShopDetails businessName={businessName} />;
};

export default BusinessProfile;